/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { Control, Controller, UseFormClearErrors } from "react-hook-form";
import Section from "../../../components/common/Section";
import { getFileExtension } from "../../../utilities/helper";
import { useEffect, useState } from "react";
import NewinputField from "../../../components/NewInput";
import NewSelectInput from "../../../components/NewSelectInput";
import {
  IconBuilding,
  IconCloudUpload,
  IconContract,
  IconPhoto,
  IconTrash,
  IconUser,
} from "@tabler/icons-react";
import { useFetchCountryWarehouseAllData } from "../../../apis/locationApis";
import { T, useLanguage } from "../../../context/LanguageContext";

export const SystemTypes = [
  { value: "phone", text: "Phone" },
  { value: "email", text: "Email" },
  { value: "whatsapp", text: "WhatsApp" },
];

type Props = {
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  clearErrors?: any;
  control: Control<any>;
  setSelectedDocument?: any;
  outSourceData?: any;
};
const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      <T>{title}</T>
    </p>
  </div>
);
const AddOutSourceModal = ({
  register,
  setValue,
  watch,
  errors,
  clearErrors,
  control,
  setSelectedDocument,
  outSourceData,
}: Props) => {
  const { t } = useLanguage();
  const [warehouse, setWarehouse] = useState<any>(watch("warehouseId") || "");
  // const { data: warehouses } = useFetchCountryWarehouseAllData();
  const { data: warehouses, refetch: fetchWarehouses } =
    useFetchCountryWarehouseAllData();

  useEffect(() => {
    if (outSourceData) {
      setValue("companyName", outSourceData?.companyName);
      setValue("contactPersonName", outSourceData?.contactPersonName);
      setValue("mobileNo", outSourceData?.mobileNo);
      setValue("email", outSourceData?.email);
      setValue("warehouseId", outSourceData?.warehouseId);
      setValue("cityId", outSourceData?.cityId);
      setValue("address", outSourceData?.address);
      setValue("specialization", outSourceData?.specialization);
      setValue("billingCycle", outSourceData?.billingCycle);
      setValue("serviceAreaCoverage", outSourceData?.serviceAreaCoverage);
      setValue(
        "contractStartDate",
        outSourceData?.contractStartDate?.split("T")?.[0],
      );
      setValue(
        "contractEndDate",
        outSourceData?.contractEndDate?.split("T")?.[0],
      );
      setValue("vatNumber", outSourceData?.vatNumber);

      setValue("vatDoc", outSourceData?.vatDoc);
      setValue("crNumber", outSourceData?.crNumber);
      setValue("crDoc", outSourceData?.crDoc);
      setValue("companyLogo", outSourceData?.companyLogo);
      setValue("primaryContactName", outSourceData?.primaryContactName);
      setValue("primaryContactNumber", outSourceData?.primaryContactNumber);
      setValue("primaryEmailAddress", outSourceData?.primaryEmailAddress);
      setValue("contractDoc", outSourceData?.contractDoc);
    }
  }, [outSourceData]);
  return (
    <div className="w-full">
      <div className=" h-[calc(100vh-10rem)] overflow-y-auto space-y-4 p-4 scrollbar-clean">
        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconBuilding} title="Company Details" />

          <Controller
            control={control}
            name="companyLogo"
            rules={{
              validate: (file: File | string | undefined) => {
                if (!file || typeof file === "string") return true;
                if (file.size > 1 * 1024 * 1024)
                  return "File size must be 1 MB or less";
                const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                const fileObj = file instanceof File ? file : null;
                if (fileObj && !allowedTypes.includes(fileObj.type)) {
                  if (
                    !["jpeg", "png", "jpg"].includes(getFileExtension(fileObj))
                  )
                    return "Only JPG, JPEG, or PNG allowed";
                }
                return true;
              },
            }}
            render={({ field, fieldState }) => {
              const fileURL =
                field.value instanceof File
                  ? URL.createObjectURL(field.value)
                  : typeof field.value === "string" && field.value !== ""
                    ? field.value
                    : "/img/dummy-logo.png";

              return (
                <div className="flex items-center gap-5 p-3 bg-gray-50/50 rounded-xl border border-dashed border-gray-200">
                  <div className="relative group">
                    <img
                      src={fileURL}
                      alt="Staff Profile"
                      className="w-20 h-20 rounded-xl object-cover border-2 border-[#FBD037]/50 shadow-md transition-all group-hover:scale-105"
                    />
                    <div className="absolute -bottom-1 -right-1 bg-[#FBD037] rounded-full p-0.5">
                      <IconPhoto size={14} className="text-white" />
                    </div>
                  </div>

                  <div className="space-y-1.5 flex-1">
                    <div className="flex items-center gap-3">
                      <input
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        className="hidden"
                        id="companyLogoUpload"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            field.onChange(file);
                            setSelectedDocument?.((prev: any) => ({
                              ...prev,
                              companyLogo: true,
                            }));
                            clearErrors("companyLogo");
                          }
                        }}
                      />
                      <label
                        htmlFor="companyLogoUpload"
                        className="inline-flex items-center gap-2 text-[#212121] cursor-pointer border rounded-lg text-sm px-4 py-1.5 border-[#FBD037] bg-[#FBD037]/20 hover:bg-[#FBD037]/30 transition-all duration-200 font-medium"
                      >
                        <IconCloudUpload size={16} stroke={1.5} />
                        <T>Upload Logo</T>
                      </label>

                      {field.value && (
                        <button
                          type="button"
                          className="inline-flex items-center gap-1 text-red-500 text-sm hover:underline transition"
                          onClick={() => {
                            field.onChange(undefined);
                            setSelectedDocument?.((prev: any) => ({
                              ...prev,
                              companyLogo: false,
                            }));
                          }}
                        >
                          <IconTrash size={14} />
                          <T>Remove</T>
                        </button>
                      )}
                    </div>

                    <p className="text-xs text-gray-400">
                      <T>Accepted formats: PNG, JPG (Max file size: 1 MB)</T>
                    </p>

                    {fieldState.error && (
                      <p className="text-red-500 text-xs font-medium mt-1 flex items-center gap-1">
                        <span className="text-red-400">⚠</span>{" "}
                        {fieldState.error.message}
                      </p>
                    )}
                  </div>
                </div>
              );
            }}
          />
          <div className="grid grid-cols-3 gap-4">
            <NewinputField
              name="companyName"
              title="Company Name"
              type="text"
              register={register}
              error={errors.companyName}
              validation={{
                required: "Company Name is required",
                pattern: {
                  value: /^(?=.*[a-zA-Z\u0600-\u06FF])[a-zA-Z\u0600-\u06FF0-9\s-]+$/,
                  message:
                    "Company Name must include at least one letter (not only numbers)",
                },
                validate: (value) => {
                  if (!value?.trim())
                    return "Company Name cannot be empty or only spaces";
                  return true;
                },
              }}
            />
            <NewinputField
              name="contactPersonName"
              title="Contact Person Name"
              type="text"
              register={register}
              error={errors.contactPersonName}
              validation={{
                required: "Contact Person Name is required",
                pattern: {
                  value: /^(?!\d+$)[a-zA-Z\u0600-\u06FF0-9\s]+$/,
                  message:
                    "Contact Person Name must contain letters (not only numbers)",
                },
                validate: (value) =>
                  value.trim().length > 0 || "Spaces are not allowed",
              }}
            />
            <NewinputField
              name="mobileNo"
              type="number"
              title="Mobile Number"
              register={register}
              error={errors.mobileNo}
              validation={{
                required: "Mobile number is required",
                pattern: {
                  value: /^\d{9,10}$/,
                  message: "Mobile number must be 9 or 10 digits",
                },
                validate: (value: string) => {
                  if (/^0+$/.test(value)) {
                    return "Mobile number cannot be all zeros";
                  }
                  return true;
                },
              }}
              other={{
                maxLength: 10,
                inputMode: "numeric",
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                  let value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setValue("mobileNo", value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                },
              }}
            />
            <NewinputField
              name="email"
              title="Mail id"
              register={register}
              error={errors.email}
              validation={{
                required: "Email is required",
                setValueAs: (value: string) => value?.toLowerCase(),
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Please enter a valid email address",
                },
              }}
            />
            <NewSelectInput
              label={"Select Warehouse"}
              name="warehouseId"
              selectOptions={
                warehouses?.warehouses?.map((warehouse: any) => ({
                  id: warehouse?.id,
                  value: warehouse?.id,
                  text: warehouse?.name,
                  cityName: warehouse?.cityName,
                })) || []
              }
              clearErrors={clearErrors}
              register={register}
              error={errors.warehouseId}
              validation={{ required: "Warehouse is required" }}
              value={watch("warehouseId")}
              setValue={(val: string) => {
                setWarehouse(val);
                const warehouse = warehouses?.warehouses?.find(
                  (c: any) => c.id === val,
                );
                setValue("warehouseId", val);
                console.log("val?.cityName <<<<<<<<<<<", warehouse?.cityName);

                setValue("cityId", warehouse?.city);
              }}
            />

            <NewinputField
              name="cityId"
              type="text"
              title="City"
              placeholder=""
              register={register}
              error={errors.cityId}
              //validation={{ required: "City is required" }}
              disabled={true}
              value={
                warehouses?.warehouses?.find(
                  (e: any) => e?.id === watch("warehouseId"),
                )?.cityName
              }
            />
            <NewinputField
              className="col-span-3"
              name="address"
              title="Address"
              register={register}
              error={errors.address}
              validation={{
                required: "Address is required",
                validate: (value: string) => {
                  const trimmed = value.trim();
                  if (trimmed.length < 10)
                    return "Address must be at least 10 characters";
                  if (trimmed.length > 100)
                    return "Address must be at most 10 characters";
                  return true;
                },
              }}
            />
          </div>
        </div>

        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconContract} title="Contract Details" />
          <div className="grid grid-cols-6 gap-4">
            <NewinputField
              className="col-span-2"
              name="specialization"
              title="Specializations"
              register={register}
            />
            <NewSelectInput
              className="col-span-2"
              label={"Billing Cycle"}
              name="billingCycle"
              selectOptions={[
                { text: "Daily", value: "DAILY" },
                { text: "Weekly", value: "WEEKLY" },
                { text: "Monthly", value: "MONTHLY" },
              ]}
              clearErrors={clearErrors}
              error={errors.billingCycle}
              register={register}
              validation={{ required: "billingCycle is required" }}
              value={watch("billingCycle")}
              setValue={(val: string) => {
                setValue("billingCycle", val);
              }}
            />
            <NewSelectInput
              className="col-span-2"
              label={"Area Coverage"}
              name="serviceAreaCoverage"
              selectOptions={[
                { text: "LOCAL", value: "LOCAL" },
                { text: "REGIONAL", value: "REGIONAL" },
              ]}
              clearErrors={clearErrors}
              error={errors.serviceAreaCoverage}
              register={register}
              validation={{ required: "serviceAreaCoverage is required" }}
              value={watch("serviceAreaCoverage")}
              setValue={(val: string) => {
                setValue("serviceAreaCoverage", val);
              }}
            />
            <NewinputField
              className="col-span-3"
              name="contractStartDate"
              type="date"
              title="Contract Start Date"
              placeholder=""
              register={register}
              error={errors.contractStartDate}
              validation={
                !outSourceData
                  ? { required: "Contract Start Date is required" }
                  : {}
              }
              disabled={!!outSourceData}
              min={
                !outSourceData
                  ? new Date().toISOString().split("T")[0]
                  : undefined
              }
            />
            {/* <NewinputField
              className="col-span-3"
              name="contractStartDate"
              type="date"
              title=" Contract Start Date"
              placeholder=""
              register={register}
              error={errors.contractStartDate}
              validation={{ required: "Contract Start Date is required" }}
              disabled={!!outSourceData}
              min={new Date().toISOString().split("T")[0]}
            /> */}
            <div className="flex items-center gap-2 col-span-3 w-full">
              <NewinputField
                name="contractEndDate"
                className="w-full"
                type="date"
                title="Contract End Date (Optional)"
                register={register}
                error={errors.contractEndDate}
                validation={{
                  validate: (value: string) => {
                    if (!value) return true;
                    const startDate = watch("contractStartDate");
                    if (startDate && new Date(value) < new Date(startDate)) {
                      return "End date cannot be before start date";
                    }
                    return true;
                  },
                }}
                min={
                  watch("contractStartDate") ||
                  new Date().toISOString().split("T")[0]
                }
              />

              <div className="mt-7">
                <Controller
                  control={control}
                  name="contractDoc"
                  rules={{
                    required: "contractDoc File is required",
                    validate: (file: File) => {
                      if (!file) return "Please select a file";

                      const MAX_SIZE = 1 * 1024 * 1024;
                      if (file?.size > MAX_SIZE) {
                        return "File size must be 1 MB or less";
                      }

                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                        "application/pdf",
                      ];
                      if (
                        file.type
                          ? !allowedTypes.includes(file.type)
                          : !["jpeg", "png", "jpg", "pdf"].includes(
                              getFileExtension(file as any),
                            )
                      ) {
                        return "Only JPG, JPEG, PDF, or PNG allowed";
                      }
                      return true;
                    },
                  }}
                  render={({ field, fieldState }) => {
                    const fileName =
                      field.value instanceof File
                        ? field.value.name
                        : typeof field.value === "string" && field.value
                          ? decodeURIComponent(
                              field.value.split("/").pop() || "",
                            )
                          : "";

                    return (
                      <div>
                        <input
                          type="file"
                          id="contract-doc"
                          className="hidden"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              field.onChange(file);
                              if (setSelectedDocument) {
                                setSelectedDocument((prev: any) => ({
                                  ...prev,
                                  contractDoc: true,
                                }));
                              }
                            }
                          }}
                        />
                        <label
                          htmlFor="contract-doc"
                          className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                        >
                          <IconCloudUpload stroke={1} size={20} />
                        </label>
                        {fieldState.error ? (
                          <p className="text-red-500 text-xs leading-tight">
                            {fieldState.error.message}
                          </p>
                        ) : fileName ? (
                          <p
                            className="text-green-600 text-xs leading-tight truncate max-w-[60px]"
                            title={fileName}
                          >
                            <T>✓ Uploaded</T>{" "}
                            {fileName.length > 12
                              ? `${fileName.slice(0, 12)}...`
                              : fileName}
                          </p>
                        ) : null}
                      </div>
                    );
                  }}
                />
              </div>
            </div>
            <div className="flex items-center gap-2 col-span-3 w-full">
              <NewinputField
                labelClass="text-sm text-[#1E293B]"
                name="vatNumber"
                className="w-full"
                type="text"
                title="VAT Number"
                placeholder="Enter 15 Digit VAT Number"
                register={register}
                error={errors?.vatNumber}
                validation={{
                  required: "Vat Number is required",
                  pattern: {
                    value: /^\d{15}$/,
                    message: "VAT number must be exactly 15 digits",
                  },
                }}
                other={{
                  maxLength: 15,
                  inputMode: "numeric",
                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 15);
                    setValue("vatNumber", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  },
                }}
              />
              <div className="mt-7">
                <Controller
                  control={control}
                  name="vatDoc"
                  rules={{
                    required: "vatDoc File is required",
                    validate: (file: File) => {
                      if (!file) return "Please select a file";

                      const MAX_SIZE = 1 * 1024 * 1024;
                      if (file?.size > MAX_SIZE) {
                        return "File size must be 1 MB or less";
                      }

                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                        "application/pdf",
                      ];
                      if (
                        file.type
                          ? !allowedTypes.includes(file.type)
                          : !["jpeg", "png", "jpg", "pdf"].includes(
                              getFileExtension(file as any),
                            )
                      ) {
                        return "Only JPG, JPEG, PDF, or PNG allowed";
                      }
                      return true;
                    },
                  }}
                  render={({ field, fieldState }) => {
                    const fileName =
                      field.value instanceof File
                        ? field.value.name
                        : typeof field.value === "string" && field.value
                          ? decodeURIComponent(
                              field.value.split("/").pop() || "",
                            )
                          : "";

                    return (
                      <div>
                        <input
                          type="file"
                          id="vat-doc"
                          className="hidden"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              field.onChange(file);
                              if (setSelectedDocument) {
                                setSelectedDocument((prev: any) => ({
                                  ...prev,
                                  vatDoc: true,
                                }));
                              }
                            }
                          }}
                        />
                        <label
                          htmlFor="vat-doc"
                          className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                        >
                          <IconCloudUpload stroke={1} size={20} />
                        </label>
                        {fieldState.error ? (
                          <p className="text-red-500 text-xs leading-tight">
                            {fieldState.error.message}
                          </p>
                        ) : fileName ? (
                          <p
                            className="text-green-600 text-xs leading-tight truncate max-w-[60px]"
                            title={fileName}
                          >
                            <T>✓ Uploaded</T>{" "}
                            {fileName.length > 12
                              ? `${fileName.slice(0, 12)}...`
                              : fileName}
                          </p>
                        ) : null}
                      </div>
                    );
                  }}
                />
              </div>
            </div>

            <div className="flex items-center gap-2 col-span-3 w-full">
              <NewinputField
                name="crNumber"
                type="number"
                title="CR Number"
                // placeholder="#5646546542"
                className="w-full"
                register={register}
                error={errors.crNumber}
                validation={{
                  required: "CR number is required",
                  pattern: {
                    value: /^\d{10}$/,
                    message: "CR number must be exactly 10 digits",
                  },
                }}
                other={{
                  maxLength: 10,
                  inputMode: "numeric",
                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    setValue("crNumber", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  },
                }}
              />

              <div className="mt-7">
                <Controller
                  control={control}
                  name="crDoc"
                  rules={{
                    required: "crDoc File is required",
                    validate: (file: File) => {
                      if (!file) return "Please select a file";

                      const MAX_SIZE = 1 * 1024 * 1024;
                      if (file?.size > MAX_SIZE) {
                        return "File size must be 1 MB or less";
                      }

                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                        "application/pdf",
                      ];
                      if (
                        file.type
                          ? !allowedTypes.includes(file.type)
                          : !["jpeg", "png", "jpg", "pdf"].includes(
                              getFileExtension(file as any),
                            )
                      ) {
                        return "Only JPG, JPEG, PDF, or PNG allowed";
                      }
                      return true;
                    },
                  }}
                  render={({ field, fieldState }) => {
                    const fileName =
                      field.value instanceof File
                        ? field.value.name
                        : typeof field.value === "string" && field.value
                          ? decodeURIComponent(
                              field.value.split("/").pop() || "",
                            )
                          : "";

                    return (
                      <div>
                        <input
                          type="file"
                          id="cr-doc"
                          className="hidden"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              field.onChange(file);
                              if (setSelectedDocument) {
                                setSelectedDocument((prev: any) => ({
                                  ...prev,
                                  crDoc: true,
                                }));
                              }
                            }
                          }}
                        />
                        <label
                          htmlFor="cr-doc"
                          className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                        >
                          <IconCloudUpload stroke={1} size={20} />
                        </label>
                        {fieldState.error ? (
                          <p className="text-red-500 text-xs leading-tight">
                            {fieldState.error.message}
                          </p>
                        ) : fileName ? (
                          <p
                            className="text-green-600 text-xs leading-tight truncate max-w-[60px]"
                            title={fileName}
                          >
                            <T>✓ Uploaded</T>{" "}
                            {fileName.length > 12
                              ? `${fileName.slice(0, 12)}...`
                              : fileName}
                          </p>
                        ) : null}
                      </div>
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconUser} title="Contact Person" />
          <div className="grid grid-cols-2 gap-4">
            <NewinputField
              className="col-span-2"
              name="primaryContactName"
              type="text"
              title="Primary Contact Name (Optional)"
              register={register}
              error={errors.primaryContactName}
              validation={{
                pattern: {
                  value: /^(?!\d+$)[a-zA-Z\u0600-\u06FF0-9\s]+$/,
                  message:
                    "Primary Contact Name must contain letters (not only numbers)",
                },
                validate: (value) =>
                  !value || value.trim().length > 0 || "Spaces are not allowed",
              }}
            />
            <NewinputField
              name="primaryContactNumber"
              type="number"
              title="Primary Phone Number (Optional)"
              // placeholder="+91 14454 65056 "
              register={register}
              error={errors.primaryContactNumber}
              validation={{
                pattern: {
                  value: /^\d{9,10}$/,
                  message: "Mobile number must be 9 or 10 digits",
                },
                validate: (value: string) => {
                  if (!value) return true;
                  if (/^0+$/.test(value)) {
                    return "Mobile number cannot be all zeros";
                  }
                  return true;
                },
              }}
              other={{
                maxLength: 10,
                inputMode: "numeric",
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                  let value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setValue("primaryContactNumber", value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                },
              }}
            />
            <NewinputField
              name="primaryEmailAddress"
              type="text"
              title="Primary Email Address (Optional)"
              // placeholder="Mail@gmail.com"
              register={register}
              error={errors.primaryEmailAddress}
              validation={{
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Please enter a valid email address",
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOutSourceModal;
